import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'

import {
  Box, FormField, DashboardModule,
} from '@campaignhub/suit-theme'

import useZonesV4 from '@hooks/useZonesV4'

import InfiniteSelect from '@components/InfiniteSelect'

const ZoneDetails = (props) => {
  const { clientForm } = props

  const {
    entityState: {
      zone,
      zone_detail,
    },
    setEntityState,
  } = clientForm

  const {
    filteredZonesV4,
    hasMore: zoneHasMore,
    loading: zoneLoading,
    callbacks: {
      loadInitialPage: loadInitialZonePage,
      loadNextPage: loadNextZonePage,
    },
  } = useZonesV4()

  useEffect(() => {
    loadInitialZonePage()
  }, [])

  const zoneOptions = useMemo(() => {
    if (!zone?.entity || !zone_detail?.name) return filteredZonesV4
    const alreadyLoaded = filteredZonesV4.some(z => z.reference === zone.entity)
    if (alreadyLoaded) return filteredZonesV4
    return [{ ...zone_detail, reference: zone.entity }, ...filteredZonesV4]
  }, [filteredZonesV4, zone, zone_detail])

  return (
    <DashboardModule title="Zone Information" boxProps={{ marginBottom: 'large' }}>
      <Box flexDirection="column" padding="large">
        <Box flexDirection={['column', 'row']} marginBottom="large" width={['100%', 'calc(50% - 4px)']}>
          <FormField
            boxProps={{ flex: 1 }}
            label="Zone"
          >
            <InfiniteSelect
              name="zone.entity"
              value={zone.entity}
              onChange={(val) => {
                zone.entity = val
                setEntityState({ zone })
              }}
              options={zoneOptions}
              onLoadMore={loadNextZonePage}
              hasMore={zoneHasMore}
              loading={zoneLoading}
              labelKey="name"
              valueKey="reference"
            />
          </FormField>
        </Box>
      </Box>
    </DashboardModule>
  )
}

ZoneDetails.propTypes = {
  clientForm: PropTypes.object,
}

export default ZoneDetails
